import { Box } from "@mui/material";
import { useBadges } from "api/badges";
import {
  CampaignConditionNewFormat,
  TransactionItemFilterType,
} from "types/campaigns";
import { useStyles } from "../../ConditionReadOnly";

interface Props {
  conditionObject: TransactionItemFilterType | CampaignConditionNewFormat;
}

export const BadgeReadOnlyParam = ({ conditionObject }: Props) => {
  const classes = useStyles();
  const { useBadgeDetails } = useBadges();
  const badge = (conditionObject as CampaignConditionNewFormat).value.params
    ?.badgeTypeId;
  const { data } = useBadgeDetails(badge);

  return <Box className={classes.box}>{data?.name}</Box>;
};
